import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _abd43936 = () => interopDefault(import('../pages/blogs/index.vue' /* webpackChunkName: "pages/blogs/index" */))
const _b2c0f89e = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _de5cf9b4 = () => interopDefault(import('../pages/evenementen/index.vue' /* webpackChunkName: "pages/evenementen/index" */))
const _7251382a = () => interopDefault(import('../pages/gegevens-aanpassen.vue' /* webpackChunkName: "pages/gegevens-aanpassen" */))
const _25598730 = () => interopDefault(import('../pages/inloggen.vue' /* webpackChunkName: "pages/inloggen" */))
const _01b55653 = () => interopDefault(import('../pages/magazine.vue' /* webpackChunkName: "pages/magazine" */))
const _5db4f7b3 = () => interopDefault(import('../pages/magazines/index.vue' /* webpackChunkName: "pages/magazines/index" */))
const _da29f3be = () => interopDefault(import('../pages/menu/index.vue' /* webpackChunkName: "pages/menu/index" */))
const _b9909630 = () => interopDefault(import('../pages/profiel.vue' /* webpackChunkName: "pages/profiel" */))
const _16b88684 = () => interopDefault(import('../pages/recepten/index.vue' /* webpackChunkName: "pages/recepten/index" */))
const _015a3de3 = () => interopDefault(import('../pages/registreren.vue' /* webpackChunkName: "pages/registreren" */))
const _21c7fa40 = () => interopDefault(import('../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */))
const _50a3439a = () => interopDefault(import('../pages/verifieer.vue' /* webpackChunkName: "pages/verifieer" */))
const _9d472e04 = () => interopDefault(import('../pages/wachtwoord-aanpassen.vue' /* webpackChunkName: "pages/wachtwoord-aanpassen" */))
const _63368d14 = () => interopDefault(import('../pages/wachtwoord-vergeten.vue' /* webpackChunkName: "pages/wachtwoord-vergeten" */))
const _9a9deac4 = () => interopDefault(import('../pages/welbewust-assortiment/index.vue' /* webpackChunkName: "pages/welbewust-assortiment/index" */))
const _2410d813 = () => interopDefault(import('../pages/zoekresultaten.vue' /* webpackChunkName: "pages/zoekresultaten" */))
const _86767df4 = () => interopDefault(import('../pages/menu/samenstellen.vue' /* webpackChunkName: "pages/menu/samenstellen" */))
const _5f5d5167 = () => interopDefault(import('../pages/services/aanvragen.vue' /* webpackChunkName: "pages/services/aanvragen" */))
const _e891a788 = () => interopDefault(import('../pages/templates/default.vue' /* webpackChunkName: "pages/templates/default" */))
const _fe4a6cba = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _af417bc6 = () => interopDefault(import('../pages/blogs/_slug.vue' /* webpackChunkName: "pages/blogs/_slug" */))
const _e1ca3c44 = () => interopDefault(import('../pages/evenementen/_slug.vue' /* webpackChunkName: "pages/evenementen/_slug" */))
const _5bfe566b = () => interopDefault(import('../pages/magazines/_slug.vue' /* webpackChunkName: "pages/magazines/_slug" */))
const _1501e53c = () => interopDefault(import('../pages/recepten/_slug.vue' /* webpackChunkName: "pages/recepten/_slug" */))
const _25353cd0 = () => interopDefault(import('../pages/services/_slug.vue' /* webpackChunkName: "pages/services/_slug" */))
const _72c2979b = () => interopDefault(import('../pages/wachtwoord-instellen/_token.vue' /* webpackChunkName: "pages/wachtwoord-instellen/_token" */))
const _9e0b2d54 = () => interopDefault(import('../pages/welbewust-assortiment/_slug.vue' /* webpackChunkName: "pages/welbewust-assortiment/_slug" */))
const _bd5a8d0a = () => interopDefault(import('../pages/*.vue' /* webpackChunkName: "pages/*" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/blogs",
    component: _abd43936,
    name: "blogs"
  }, {
    path: "/contact",
    component: _b2c0f89e,
    name: "contact"
  }, {
    path: "/evenementen",
    component: _de5cf9b4,
    name: "evenementen"
  }, {
    path: "/gegevens-aanpassen",
    component: _7251382a,
    name: "gegevens-aanpassen"
  }, {
    path: "/inloggen",
    component: _25598730,
    name: "inloggen"
  }, {
    path: "/magazine",
    component: _01b55653,
    name: "magazine"
  }, {
    path: "/magazines",
    component: _5db4f7b3,
    name: "magazines"
  }, {
    path: "/menu",
    component: _da29f3be,
    name: "menu"
  }, {
    path: "/profiel",
    component: _b9909630,
    name: "profiel"
  }, {
    path: "/recepten",
    component: _16b88684,
    name: "recepten"
  }, {
    path: "/registreren",
    component: _015a3de3,
    name: "registreren"
  }, {
    path: "/services",
    component: _21c7fa40,
    name: "services"
  }, {
    path: "/verifieer",
    component: _50a3439a,
    name: "verifieer"
  }, {
    path: "/wachtwoord-aanpassen",
    component: _9d472e04,
    name: "wachtwoord-aanpassen"
  }, {
    path: "/wachtwoord-vergeten",
    component: _63368d14,
    name: "wachtwoord-vergeten"
  }, {
    path: "/welbewust-assortiment",
    component: _9a9deac4,
    name: "welbewust-assortiment"
  }, {
    path: "/zoekresultaten",
    component: _2410d813,
    name: "zoekresultaten"
  }, {
    path: "/menu/samenstellen",
    component: _86767df4,
    name: "menu-samenstellen"
  }, {
    path: "/services/aanvragen",
    component: _5f5d5167,
    name: "services-aanvragen"
  }, {
    path: "/templates/default",
    component: _e891a788,
    name: "templates-default"
  }, {
    path: "/",
    component: _fe4a6cba,
    name: "index"
  }, {
    path: "/blogs/:slug",
    component: _af417bc6,
    name: "blogs-slug"
  }, {
    path: "/evenementen/:slug",
    component: _e1ca3c44,
    name: "evenementen-slug"
  }, {
    path: "/magazines/:slug",
    component: _5bfe566b,
    name: "magazines-slug"
  }, {
    path: "/recepten/:slug",
    component: _1501e53c,
    name: "recepten-slug"
  }, {
    path: "/services/:slug",
    component: _25353cd0,
    name: "services-slug"
  }, {
    path: "/wachtwoord-instellen/:token?",
    component: _72c2979b,
    name: "wachtwoord-instellen-token"
  }, {
    path: "/welbewust-assortiment/:slug?",
    component: _9e0b2d54,
    name: "welbewust-assortiment-slug"
  }, {
    path: "/*",
    component: _bd5a8d0a,
    name: "*"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
